import script from "./TutorSecurityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorSecurityForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorSecurityForm.vue?vue&type=style&index=0&id=d9b43930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9b43930"]])

export default __exports__